var _defs, _use, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg09D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 99.5,
    x2: 232.6,
    y1: 30.7,
    y2: 261.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1314.8,
    x2: 1324.2,
    y1: -739.9,
    y2: -715.3,
    gradientTransform: "rotate(-9 7682.04 6929.539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b65ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0a5ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 1370.1,
    x2: 1379.5,
    y1: -731.1,
    y2: -706.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 1425.4,
    x2: 1434.9,
    y1: -722.4,
    y2: -697.8
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m291 107-2.5.1A83.9 83.9 0 00135.6 43 56 56 0 0051 91a56.6 56.6 0 00.8 9A60 60 0 0063 219l4-.2v.2h224a56 56 0 000-112Z"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 350,
    height: 222,
    transform: "translate(81 145)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M200 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "d",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; d.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "e",
    attributeName: "opacity",
    begin: "0s; e.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M256 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x2",
    additive: "sum",
    attributeName: "transform",
    begin: "1.34s; x2.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y2",
    attributeName: "opacity",
    begin: "1.34s; y2.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M312 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "h",
    additive: "sum",
    attributeName: "transform",
    begin: ".67s; h.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "i",
    attributeName: "opacity",
    begin: ".67s; i.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09D);
export default __webpack_public_path__ + "static/media/09d.bfc5308f7ce2248b469286cf7e80b467.svg";
export { ForwardRef as ReactComponent };